import React from 'react';
import { KONTRA_BLUE_LIGHT, KONTRA_BLUE_LIGHT_DISABLED } from '../../../styles/colors';

const styles = {
  selected: {
    height: '100%',
    width: '100%',
    backgroundColor: KONTRA_BLUE_LIGHT,
    color: 'black'
  },
  locked: {
    height: '100%',
    width: '100%',
    backgroundColor: KONTRA_BLUE_LIGHT_DISABLED,
    color: 'black'
  },
  notSelected: {
    height: '100%',
    width: '100%',
    backgroundColor: 'transparent'
  }
}

const DataCell = ({ data: { text, startDate } }, selectedDates, locked) => {
  return (
    <div 
      style={
        selectedDates.includes(startDate.getTime().toString()) ?
        (locked ? styles.locked : styles.selected) :
        styles.notSelected
      }
    >
      { text }
    </div>
  )
}

export default DataCell;